import React, { useState, useEffect } from "react";
import KhataList from "./KhataList";
import Khata from "views/Khata";
import NoKhata from "views/NoKhata";
import useUniversalStore from "store/universalStore";
import Onboarding from "views/Onboarding";
import { Loader } from "components";

const index = () => {
  const {accountId, accounts} = useUniversalStore((state) => state);

  return (
    <div className="container-fluid">
      <div className="row vh-100">
        <div className="col-4 col-md-4 px-0 mx-0">
          { accounts ? <KhataList /> : <Loader />}
        </div>
        <div className="col-4 col-md-8 border-start px-0 mx-0">
          {accountId ? <Khata /> : <NoKhata />}
        </div>

      </div>
      <Onboarding />
    </div>
  )
}

export default index;